import { useState } from 'react'
import Select from 'react-select'
import classNames from 'classnames'
import { isDisabled } from '../../utils'
import { BEHAVIOR_TYPE } from '../../constants'
import { getSelectFieldChoices, calcMaxLength } from './AppObjectFieldUtils'

export default function AppObjectFieldMultiSelect(props) {
  const { field, object, formInputs, parentObjectId, action, value, handleChange, hasChanged, inputAttribute } = props
  console.log(`AppObjectFieldMultiSelect rendered: ${field.name}`, props)

  const [choicesRetrieved, setChoicesRetrieved] = useState(false)

  function localHandleChange(selectedValues) {
    setSelectedItems(selectedValues)
    handleChange(selectedValues, hasChanged, field.id)
  }

  let currentValue = []
  let initialOptions = []
  if (value && value.length > 0) {
    for (let item of value) {
      currentValue.push({ value: item.id, label: item.name })
    }
    if (!choicesRetrieved) {
      initialOptions.push(currentValue)
    }
  }
  const [options, setOptions] = useState(initialOptions)
  const [selectedItems, setSelectedItems] = useState(currentValue)

  async function handleFocus() {
    console.log('AppObjectFieldMultiSelect.hanldeFocus choiceType: ', field.choiceType, 'choiceValue: ', field.choiceValue, 'choicesRetrieved: ', choicesRetrieved)
    if (!choicesRetrieved) {
      const choiceValues = await getSelectFieldChoices(field, object, parentObjectId, formInputs)
      setChoicesRetrieved(true)
      setOptions(choiceValues)
    }
  }

  if (isDisabled(action, field.behaviorType)) {
    let selecteItemsString = ''
    let comma = ''
    if (value && value.length > 0) {
      for (let item of value) {
        selecteItemsString += `${comma} ${item.name}`
        comma = ', '
      }
    }
    return (<span>{selecteItemsString}</span>)
  }

  const maxLength = calcMaxLength(options)
  const isClearable = (field.behaviorType.id === BEHAVIOR_TYPE.required) ? false : true

  let retrievedIndicator = ''
  if (choicesRetrieved) {
    retrievedIndicator = <div data-cy-options-retrieved={`field-${field.id}`}/>
  }

  return (
    <div style={{ minWidth: `${(5 * maxLength) + 150}px` }} data-cy={`field-${field.id}`}>
      <Select
        valid={inputAttribute === 'valid'}
        invalid={inputAttribute === 'invalid'}
        name={field.id}
        className={classNames('app-object-field-select', { 'invalid': inputAttribute === 'invalid' }, { 'valid': inputAttribute === 'valid' })}
        id={field.id}
        value={selectedItems}
        onChange={(event) => localHandleChange(event)}
        onFocus={handleFocus}
        isClearable={isClearable}
        options={options}
        closeMenuOnSelect={false}
        isMulti
      />
      {retrievedIndicator}
    </div>
  )
}
